import React, { useEffect, useCallback, useState} from 'react';
import {BANG} from "messaging/message-types.js"
import {connect} from 'react-redux';
import './button.scss';

const ZButtonPresser = ({zobject, attributes}) => { 
    let style = {
        width: zobject.width - 10,
        height: zobject.width - 10,
        borderRadius: zobject.width - 10,
        borderColor: attributes["secondary-color"],
        backgroundColor: attributes["button-color"],
    };
    return (
        <div
          style={style}
          onMouseLeave={() => zobject.effect.sendMessage("on released", BANG)}
          onMouseDown={() => zobject.effect.sendMessage("on pressed", BANG)}
          onMouseUp={() => zobject.effect.sendMessage("on released", BANG)}
          className="z-button-presser">
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
      width: props.zobject.width,
      height: props.zobject.height,
      attributes: props.zobject.attributes
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ZButtonPresser);
